// Initialize theme object
window.theme = window.theme || {};

import '../scripts/legacy/';
import '../scripts/components/';
import '../scripts/utils/helpers';
import '../scripts/utils/scroll-to';

// Development-only logging

console.log('main.bundle.js loaded');

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
